import { render, staticRenderFns } from "./cProjects.vue?vue&type=template&id=5b660180&"
import script from "./cProjects.vue?vue&type=script&lang=js&"
export * from "./cProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports